import { observe } from 'selector-observer';

function showCopyPopover(button: HTMLElement, content: string): void {
  const tooltip = window.bootstrap.Tooltip.getInstance(button);
  if (tooltip) {
    tooltip.hide();
  }

  const existingPopover = window.bootstrap.Popover.getInstance(button);
  existingPopover?.dispose();

  const popover = window.bootstrap.Popover.getOrCreateInstance(button, {
    content,
    placement: 'bottom',
    trigger: 'manual',
  });
  popover.show();
  window.setTimeout(() => popover.hide(), 1000);
}

observe(
  '.btn-copy[data-clipboard-text], .btn-copy[data-clipboard-target], .js-copy-button[data-clipboard-text], .js-copy-button[data-clipboard-target]',
  {
    constructor: HTMLElement,
    add(button) {
      button.addEventListener('click', (event) => {
        event.stopPropagation();
        const { clipboardText, clipboardTarget } = button.dataset;

        let text: string;
        if (clipboardText != null) {
          text = clipboardText;
        } else if (clipboardTarget != null) {
          text = Array.from(
            document.querySelectorAll(clipboardTarget),
            (el) => el.textContent ?? '',
          ).join('');
        } else {
          return;
        }

        if (!navigator.clipboard) {
          showCopyPopover(button, 'Copy failed');
          return;
        }

        void navigator.clipboard
          .writeText(text)
          .then(() => showCopyPopover(button, 'Copied!'))
          .catch((err: unknown) => {
            console.error('Failed to copy text to clipboard', err);
            showCopyPopover(button, 'Copy failed');
          });
      });
    },
  },
);
